import { Component, input } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DatepickerFieldComponent } from '../../../atoms/forms/datepicker-field/datepicker-field.component';
import { ErrorFieldComponent } from '../../../atoms/forms/error-field/error-field.component';
import { ErrorTypeLabels, DEFAULT_ERROR_TYPE_LABELS } from '../../../shared/interfaces/error-messages.interface';

@Component({
  selector: 'htx-datepicker-field-with-error',
  imports: [CommonModule, DatepickerFieldComponent, ErrorFieldComponent],
  templateUrl: './datepicker-field-with-error.component.html',
  styleUrl: './datepicker-field-with-error.component.scss',
  standalone: true
})
export class DatepickerFieldWithErrorComponent {
  /** The FormControl that manages the datepicker value and validation state */
  ctrl = input.required<AbstractControl>();

  /** The label text displayed above the datepicker */
  label = input<string>();

  /** Whether the field is required and should display a red asterisk indicator */
  required = input<boolean>(false);

  /** Custom error messages for different validation types */
  errorMessages = input<ErrorTypeLabels>(DEFAULT_ERROR_TYPE_LABELS);

  /**
   * Returns the control as a FormControl for direct access to its properties and methods.
   */
  getControl(): FormControl {
    return this.ctrl() as FormControl;
  }
}
